import { render, staticRenderFns } from "./BackInsNews.vue?vue&type=template&id=16043663&scoped=true"
import script from "./BackInsNews.vue?vue&type=script&lang=js"
export * from "./BackInsNews.vue?vue&type=script&lang=js"
import style0 from "./BackInsNews.vue?vue&type=style&index=0&id=16043663&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16043663",
  null
  
)

export default component.exports